/** SR&ED tax credit checklist. */
export const SRED_TASKS = [
  {
    id: 1,
    name: "Engagement & scope",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm SR&ED eligibility with client", completed: false },
      { id: "1-2", name: "Define claim year and project scope", completed: false },
      { id: "1-3", name: "Collect signed engagement letter", completed: false },
    ],
  },
  {
    id: 2,
    name: "Technical narrative",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Interview technical team on R&D work", completed: false },
      { id: "2-2", name: "Draft technical uncertainty and advancement", completed: false },
      { id: "2-3", name: "Client review of technical narrative", completed: false },
    ],
  },
  {
    id: 3,
    name: "Financial claim",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Gather payroll and contractor records", completed: false },
      { id: "3-2", name: "Calculate eligible expenditures", completed: false },
      { id: "3-3", name: "Complete T661 (SR&ED expenditures claim)", completed: false },
      { id: "3-4", name: "Complete federal ITC schedule (T2SCH31 or T2038 IND)", completed: false },
      { id: "3-5", name: "Complete provincial schedules for PE province (ON / AB / BC / etc.)", completed: false },
    ],
  },
  {
    id: 4,
    name: "File & follow up",
    completed: false,
    subtasks: [
      { id: "4-1", name: "Submit claim with corporate tax return", completed: false },
      { id: "4-2", name: "Respond to CRA review if applicable", completed: false },
    ],
  },
];
